import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import "../assets/styles/common-header-footer.scss";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="common-footer">
      <div className="common-footer-container">
        <div className="common-footer-content">
          {/* About Section */}
          <div className="common-footer-section">
            <h5 className="common-footer-title">About Us</h5>
            <p className="common-footer-text">
              We are a trusted marketplace connecting buyers and sellers worldwide.
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="common-footer-section">
            <h5 className="common-footer-title">Quick Links</h5>
            <ul className="common-footer-links">
              <li>
                <Link to="/about" className="common-footer-link">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="common-footer-link">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/login" className="common-footer-link">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/signup" className="common-footer-link">
                  Register
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="common-footer-section">
            <h5 className="common-footer-title">Contact</h5>
            <div className="common-footer-contact">
              <p className="common-footer-contact-item">
                <span className="common-footer-contact-icon">📍</span>
                123 Trocanet Street, Trocanet, Trocanet
              </p>
              <p className="common-footer-contact-item">
                <span className="common-footer-contact-icon">📧</span>
                support@trocanet.com
              </p>
              <p className="common-footer-contact-item">
                <span className="common-footer-contact-icon">📞</span>
                +1 800 123 4567
              </p>
            </div>
            <div className="common-footer-social">
              <FaFacebook className="common-footer-social-icon" role="button" aria-label="Facebook" />
              <FaTwitter className="common-footer-social-icon" role="button" aria-label="Twitter" />
              <FaInstagram className="common-footer-social-icon" role="button" aria-label="Instagram" />
              <FaLinkedin className="common-footer-social-icon" role="button" aria-label="LinkedIn" />
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="common-footer-divider" />

        {/* Copyright */}
        <p className="common-footer-copyright">
          © {currentYear} <span className="common-footer-copyright-brand">Trocanet</span>. All rights reserved.
        </p>
      </div>
    </footer>
  );
}


